import { formatDate, isDateThisWeek, isDateToday, isDateYesterday } from '../../../utils/dates';
import { Locales } from '../../translation/messages';

export const formatChatTime = (date: Date, locale: string) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  if (isDateToday(date)) {
    return formatDate(date, 'HH:mm', timeZone);
  }

  if (isDateYesterday(date)) {
    if (locale.includes(Locales.ENGLISH)) {
      return 'yesterday';
    } else if (locale.includes(Locales.SPANISH)) {
      return 'ayer';
    } else {
      return 'ontem';
    }
  }

  if (isDateThisWeek(date)) {
    return formatDate(date, 'eeee', timeZone);
  }

  return formatDate(date, undefined, timeZone);
};
